<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-card class="inner-block progress-status">
            <b-card-header>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex">
                        <b-input id="search-input" type="text" :placeholder="$translate('search')"
                            v-model="query"></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-col class="page-block">
                    <strong>
                        {{ $translate("page") }}: {{ pagination.page }}
                        {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                        {{ pagination.total }}
                    </strong>
                </b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <div class="responsive-table">
                        <b-table class="table table-striped" :fields="fields" :items="templates"
                            :per-page="itemsPerPage" :current-page="currentPage" :filter="filters" show-empty>
                            <template #cell(id)="{ item }">
                                <b-button :id="'view-rpa-template-btn' + item.id" class="test-view-rpa-template-btn"
                                    v-if="hasPermissionView" @click="$emit('show-item', item.id)" variant="pink-button">
                                    <img src="@/assets/images/icon/view.svg" />
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-card-body>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                        :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                        :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                        align="center"></b-pagination>

                </b-col>
            </b-row>
        </b-card>
    </b-overlay>
</template>
<script>
import { capitalCase } from 'change-case'
import _ from "lodash";
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import dateTimeMixins from "@/mixins/dateTimeMixins";

export default {
    name: 'RpaTemplates-ListItems',
    mixins: [popupMixins, permissionsMixins, dateTimeMixins],
    props: {
        //type, // not used
        /**
         * The title of the table
         */
        title: String,
    },
    components: {},

    data() {
        return {
            filters: {
            },
            query: '',
            itemsPerPage: 15,
            tableLoading: false,
            currentPage: 1,
            rowsLength: this.rows,
        }
    },
    watch: {
        query: _.debounce(function (val) {
            this.doSearch(false, val);
        }, 500)
    },

    mounted() {
        this.doSearch(true)
    },


    computed: {
        fields() {
            const { displayLocalDate } = this;
            return [
                { key: 'id', label: this.$translate('actions') },
                {
                    key: 'name',
                    label: this.$translate('name'),
                },
                {
                    key: 'order_type',
                    label: this.$translate('activity_type'),
                    formatter: (value) => value?.name
                },
                {
                    key: 'erp_vendor_id',
                    label: `${this.$translate('erp_vendor_id')}`,
                },

            ]
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.rpaTemplate.pagination || { page: 1 };
        },
        templates() {
            return this.$store.state.rpaTemplate.templates || []
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.templates.length
        }
    },

    methods: {
        async doSearch(isforcedReload = false, query) {
            try {

                let {
                    pagination: { page },
                    filters
                } = this

                query = query || this.query;

                page = parseInt(page) || 1;

                this.tableLoading = true

                await this.$store.dispatch('rpaTemplate/fetchAll', {
                    query,
                    filters,
                    page,
                    isforcedReload
                })
            } catch (err) {
                console.log('rpaTemplate fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
            }
        },
    },
}
</script>
<style></style>
